import * as Sentry from '@sentry/react';

// normalizeDsn strips dashes from GlitchTip UUID keys.
// The Sentry SDK rejects DSN usernames containing dashes.
// Mirrors the fleet convention (dao-suite/src/utils/sentry.ts).
export function normalizeDsn(dsn: string): string {
  try {
    const url = new URL(dsn);
    if (url.username.includes('-')) {
      url.username = url.username.replace(/-/g, '');
      return url.toString();
    }
    return dsn;
  } catch {
    return dsn;
  }
}

// Wires GlitchTip (browser tier) for this SPA. The DSN comes from the
// VITE_SENTRY_DSN build env (sourced from the GLITCHTIP_DSN staging secret at
// build time). Absent DSN => no-op (local dev / unset). Events land in the
// shared web-suites project; setTag('spa', ...) discriminates per suite.
export function initSentry(suiteTag: string): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn: normalizeDsn(dsn),
    environment: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'development',
    release: `hw-${suiteTag}@${import.meta.env.VITE_GIT_SHA || 'local'}`,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error instanceof TypeError && error.message.includes('Failed to fetch')) return null;
      if (error instanceof Error && error.message.includes('ResizeObserver')) return null;
      if (error instanceof Error && error.name === 'AbortError') return null;
      return event;
    },
  });

  Sentry.setTag('spa', suiteTag);
}
